/* eslint-disable import/prefer-default-export */
export const LOGIN_DRAWER = 'LOGIN_DRAWER';
export const PRACTICE_REMINDER_DRAWER = 'PRACTICE_REMINDER_DRAWER';
export const SNACKBAR = 'GLOBAL:SNACKBAR';
export const DOUBTS_FEEDBACK_DRAWER = 'DOUBTS:FEEDBACK_DRAWER';
export const POST_CLASS_RECOMMENDATION_DIALOG =
  'GLOBAL:POST_CLASS_RECOMMENDATION_DIALOG';
